<section class="habirint-table" [class.privilege-active]="privilegeSettings.length">
  <table *ngIf="lesson?.is_habirint && habirintData" class="habirint-table__table">
    <thead class="habirint-table__table__head">
      <tr>
        <th *ngFor="let box of boxes">
          {{ box.title }}
        </th>
      </tr>
    </thead>
    <tbody class="habirint-table__table__body">
      <tr *ngFor="let studentData of sortingStudents" class="habirint-table__table__body__row">
        <td *ngFor="let box of studentData.boxes; let i = index;" class="habirint-table__table__body__row__column">
          <span class="habirint-table__table__body__row__column__item" [class.active]="box.is_correct"
            [ngStyle]="{'background-color': columnBackgrounds[i]}"></span>
        </td>
      </tr>
      <tr>
        <td class="habirint-table__table__body__row__column" *ngFor="let boxData of habirintData?.boxes_rewards; let i = index">
          <span *ngIf="!boxData.is_correct"
            class="habirint-table__table__body__row__column__reward">
            {{ boxData.reward }}
          </span>
          <span *ngIf="boxData.is_correct"
            class="habirint-table__table__body__row__column__reward reward-active" [ngStyle]="{'border-color': columnBackgrounds[i], 'color': columnBackgrounds[i]}">
            {{ boxData.reward }}
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</section>